import { TableField, cumpriuNaoCumpriuBooleanFormatter, defaultDateFormatter } from "@/types/table-field";


const baseLegal: TableField = {
    key: "BaseLegal",
    label: "Base Legal",
    tdClass: "align-middle",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const detalheBaseLegal: TableField = {
    key: "DetalheBaseLegal",
    label: "Detalhe Base Legal",
    tdClass: "align-middle",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const fonte: TableField = {
    key: "Fonte",
    label: "Fonte",
    tdClass: "align-middle",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const resultado: TableField = {
    key: "Resultado",
    label: "Resultado",
    tdClass: "align-middle",
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
    formatter: cumpriuNaoCumpriuBooleanFormatter,
};
const ultimaAlteracao: TableField = {
    key: "UsuarioUltAlt",
    label: "Usuário",
    tdClass: ["align-middle","font-italic"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const dataAlteracao: TableField = {
    key: "DataUltAlt",
    label: "Data",
    tdClass: ["align-middle"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
    formatter: defaultDateFormatter
};
const actions = {
    key: "acao",
    label: "",
    tdClass: ["align-middle", "min4rem"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsItensAnalisados: TableField[] = [
    baseLegal,
    detalheBaseLegal,
    fonte,
    resultado,
    ultimaAlteracao,
    dataAlteracao,
    actions,
];
